import { AllowedRole, SidebarItem, UserType } from "@/types/user.types";
import { PERMISSIONS } from "@/utils/constant/global.constant";

const dashboardSideBarForInternalUser: SidebarItem[] = [
  {
    name: "QA",
    key: "/qa",
    iconUrl: "/icons/dashboard-sidebar-internal-qa.svg",
    userTypes: ["INTL"],
    roles: ["QA"],
    permId: "all",
    isDefault: true,
    content: {
      type: "sidebar",
      defaultKey: "/qa/generate-token",
      sidebars: [
        {
          name: "Generate Token",
          key: "/qa/generate-token",
          userTypes: ["INTL"],
          roles: ["QA"],
          permId: "qa-generate-token",
          content: { type: "view" },
        },
        {
          name: "Payload",
          key: "/qa/payload",
          userTypes: ["INTL"],
          roles: ["QA"],
          permId: "qa-payload",
          content: { type: "view" },
        },
      ],
    },
  },
  {
    name: "Product",
    key: "/product",
    iconUrl: "/icons/dashboard-sidebar-internal-qa.svg",
    userTypes: ["INTL"],
    roles: ["PRODUCT"],
    permId: "all",
    isDefault: true,
    content: {
      type: "sidebar",
      defaultKey: "/product/verify-account",
      sidebars: [
        {
          name: "Verify Account",
          key: "/product/verify-account",
          userTypes: ["INTL"],
          roles: ["PRODUCT"],
          permId: "product-verify-account",
          content: { type: "view" },
        },
      ],
    },
  },
  {
    name: "Organizations",
    key: "/internal/organizations",
    iconUrl: "/icons/profile-white.svg",
    userTypes: ["INTL"],
    roles: ["ALL"],
    permId: "all",
    content: {
      type: "view",
      viewName: "organizations-view",
    },
  },
];

const dashboardSideBar: SidebarItem[] = [
  {
    name: "Home",
    key: "/home",
    iconUrl: "/icons/dashboard-sidebar-home.svg",
    roles: ["ALL"],
    permId: "all",
    userTypes: ["ORG", "IDV", "VFR"],
    isHidden: true,
    content: {
      type: "sidebar",
      isStandAlone: true,
      defaultKey: "/home/profile",
      sidebars: [
        {
          name: "Profile",
          key: "/home/profile",
          roles: ["ALL"],
          permId: "all",
          userTypes: ["ALL"],
          content: { type: "view" },
        },
        {
          name: "Documents",
          key: "/home/documents",
          roles: ["ALL"],
          permId: "view-documents",
          userTypes: ["IDV"],
          content: { type: "view" },
        },
        {
          name: "Security",
          key: "/home/security",
          roles: ["ALL"],
          permId: "all",
          userTypes: ["ALL"],
          content: { type: "view" },
        },
      ],
    },
    moduleSetup: {
      key: "setup",
      name: "Dashboard Setup",
      roles: ["ALL"],
      userTypes: ["ALL"],
    },
  },
  {
    name: "Home",
    key: "/dashboard",
    iconUrl: "/icons/dashboard-sidebar-home.svg",
    roles: ["ALL"],
    notRoles: ["User"],
    permId: "all",
    userTypes: ["ALL"],
    isDefault: true,
    hideBreadCrumb: true,
    content: {
      type: "view",
      viewName: "home-view",
    },
    moduleSetup: {
      key: "setup",
      name: "Dashboard Setup",
      roles: ["ALL"],
      userTypes: ["ALL"],
    },
  },
  {
    name: "Employees",
    key: "/home/employees",
    iconUrl: "/icons/dashboard-sidebar-employee.svg",
    roles: ["Account Owner", "Account Admin"],
    permId: [PERMISSIONS.EMPLOYEE["View Employees"], PERMISSIONS.EMPLOYEE["View Reporting Employee"]],
    userTypes: ["ORG"],
    skipContentSideBar: ["/home/employees"],
    content: {
      type: "view",
      viewName: "employees-view",
    },
    moduleSetup: {
      key: "setup",
      name: "Add employees",
      roles: ["Account Owner"],
      userTypes: ["ORG"],
    },
  },
  {
    name: "Employment details",
    key: "/home/employment-details",
    path: "/home/employment-details/:currentEmpExtId/overview",
    isDynamicPath: true,
    iconUrl: "/icons/profile-white.svg",
    roles: ["Account Owner", "Account Admin"],
    notRoles: ["Account Owner"],
    permId: PERMISSIONS.EMPLOYEE["View Own Employee"],
    userTypes: ["ORG"],
    content: {
      type: "view",
      viewName: "employees-view",
    },
  },
  {
    name: "Payments History",
    key: "/home/Payments-history",
    iconUrl: "/icons/payment.svg",
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.PAYMENT["View Payment History"],
    userTypes: ["ORG"],
    content: {
      type: "view",
      viewName: "payment-history-view",
    },
  },
  {
    name: "Settings",
    key: "/home/settings",
    iconUrl: "/icons/dashboard-sidebar-setting.svg",
    roles: ["ALL"],
    permId: "all",
    notRoles: ["User"],
    userTypes: ["IDV", "ORG", "VFR"],
    skipContentSideBar: ["/home/settings", "/home/settings/roles", "/home/settings/roles/manage-permissions"],
    content: {
      type: "sidebar",
      defaultKey: "/home/settings",
      sidebars: [
        {
          name: "Organization profile",
          key: "/home/settings/organization-profile",
          roles: ["Account Owner", "Account Admin"],
          permId: "all",
          userTypes: ["ORG"],
          content: { type: "view" },
        },
        {
          name: "Verifier profile",
          key: "/home/settings/organization-profile",
          roles: ["Account Owner"],
          permId: "all",
          userTypes: ["VFR"],
          content: { type: "view" },
        },
        {
          name: "Documents",
          key: "/home/settings/documents",
          roles: ["Account Owner", "Account Admin"],
          permId: PERMISSIONS.SETTING["View Documents"],
          userTypes: ["ORG", "VFR"],
          content: { type: "view" },
        },
        {
          name: "Signatory",
          key: "/home/settings/signatory",
          roles: ["Account Owner", "Account Admin"],
          permId: PERMISSIONS.SETTING["View Signatory"],
          userTypes: ["ORG", "VFR"],
          content: { type: "view" },
        },
        {
          name: "Letterhead",
          key: "/home/settings/letterhead",
          roles: ["Account Owner", "Account Admin"],
          permId: PERMISSIONS.SETTING["View Letterhead"],
          userTypes: ["ORG", "VFR"],
          content: { type: "view" },
        },
        // {
        //   name: "Roles and permission",
        //   key: "/home/setting/roles-and-permission",
        //   roles: ["Account Owner", "Account Admin"],
        //   permId: "View Roles and Permission",
        //   userTypes: ["ORG"],
        //   content: { type: "view" },
        //   hideContentSideBar: true,
        // },
      ],
      mainSidebars: [
        {
          name: "Organization profile",
          key: "/home/settings/organization-profile",
          roles: ["Account Owner", "Account Admin"],
          permId: "View Organization Profile",
          userTypes: ["ORG"],
          content: { type: "view" },
        },
        {
          name: "Roles",
          key: "/home/settings/roles",
          roles: ["Account Owner", "Account Admin"],
          permId: "View Roles and Permission",
          userTypes: ["ORG"],
          content: { type: "view" },
        },
      ],
    },
  },
  ...dashboardSideBarForInternalUser,
];

// to filter sidebar items based on user type and role
export const filterSidebarItems = (
  items: SidebarItem[],
  userType: UserType,
  userRole: AllowedRole,
  perms: { moduleId: number; permissionIds: string[] }[],
  currentEmpExtId?: string | undefined,
  isCloneUserRole?: boolean | undefined
): SidebarItem[] => {
  const allPermissions = perms.flatMap((p) => p.permissionIds);
  return items
    .map((item) => {
      const isUserTypeAllowed = item.userTypes.includes("ALL") || item.userTypes.includes(userType);
      if (item?.notRoles) {
        if (item.notRoles.includes(userRole)) {
          return undefined;
        }
        // Hide for any user with role 'User' or if isCloneUserRole is true
        if (item.notRoles.includes("User") && (userRole === "User" || isCloneUserRole)) {
          return undefined;
        }
      }
      if (item.isDynamicPath && item.path && currentEmpExtId) {
        item.path = item.path.replace(":currentEmpExtId", currentEmpExtId);
      }
      // const isRoleAllowed = item.roles.includes("ALL") || item.roles.includes(userRole);
      const hasPermission =
        item.permId === "all" ||
        (Array.isArray(item.permId) ? item.permId.some((id) => allPermissions.includes(id)) : allPermissions.includes(item.permId || ""));
      if (isUserTypeAllowed && hasPermission) {
        if (item.content.type === "sidebar" && Array.isArray(item.content.sidebars)) {
          const filteredSidebars = filterSidebarItems(item.content.sidebars, userType, userRole, perms);
          if (filteredSidebars.length > 0) {
            return {
              ...item,
              content: {
                ...item.content,
                sidebars: filteredSidebars,
              },
            };
          }
          return undefined;
        }
        return item;
      }
      return undefined;
    })
    .filter((item): item is SidebarItem => item !== undefined);
};

interface GetDashboardSideBarConfigProps {
  userType: UserType | undefined;
  userRole: AllowedRole | undefined;
  perms: { moduleId: number; permissionIds: string[] }[];
  currentEmpExtId?: string | undefined;
  isCloneUserRole?: boolean | undefined;
}

export const getDashboardSideBarConfig = ({ userType, userRole, perms, currentEmpExtId, isCloneUserRole }: GetDashboardSideBarConfigProps) => {
  if (!userRole || !userType) return;
  return filterSidebarItems(dashboardSideBar, userType, userRole, perms, currentEmpExtId, isCloneUserRole);
};

export const CANCEL_DIRTY_FORM = {
  message: "Are you sure to discard the changes?",
  confirmText: "Discard",
  cancelText: "Keep editing",
};
